/**
 * Módulo de reportes formales (#47). Una sola vista: el generador y el
 * documento que produce.
 *
 * `minimumRole: 'analyst'` — la acción principal de la vista es pedir una
 * exportación, y `POST /api/v1/exports` exige `analyst`. Un `viewer` vería
 * una pantalla cuyo botón sólo puede terminar en 403.
 */
import type { ModuleRoutes } from '../module';
import { ReportsPage } from './ReportsPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'reports',
  minimumRole: 'analyst',
  routes: [{ path: '', element: <ReportsPage /> }],
};
